import { Icon } from '../../../../layout/Icon.jsx';
import { Pill } from '../../../../layout/Pill.jsx';
import { formatIQD, formatDuration } from '../../../../shared/format.js';

export function PackageCard({ pkg, canEdit, onEdit, onDelete }) {
  return (
    <div className="card p-4 flex flex-col gap-2">
      <div className="flex items-start justify-between gap-2">
        <div className="text-[15px] font-bold">{pkg.name}</div>
        <div className="flex flex-wrap gap-1.5">
          {pkg.isOpenTime ? <Pill variant="info">وقت مفتوح</Pill> : null}
          {pkg.isActive === false ? <Pill variant="muted">معطّلة</Pill> : <Pill variant="success">فعّالة</Pill>}
        </div>
      </div>
      <div className="text-[12.5px] text-ink-2">
        {pkg.isOpenTime ? 'بدون مدة محددة' : `المدة: ${formatDuration(pkg.durationMinutes || 0)}`}
      </div>
      <div className="text-[20px] font-extrabold" style={{ color: '#C2570D' }}>
        {formatIQD(pkg.price || 0)}
      </div>
      {pkg.extraHourPrice ? (
        <div className="text-[11.5px] text-ink-3">
          إضافي: {formatIQD(pkg.extraHourPrice)}/ساعة
        </div>
      ) : null}
      {pkg.description ? (
        <div className="text-[12px] text-ink-2 line-clamp-2">{pkg.description}</div>
      ) : null}
      {canEdit ? (
        <div className="flex items-center gap-1.5 mt-1">
          <button
            type="button"
            className="btn flex-1 justify-center"
            style={{ padding: '6px 10px', fontSize: 12 }}
            onClick={() => onEdit?.(pkg)}
          >
            <Icon name="edit" size={13} /> تعديل
          </button>
          <button
            type="button"
            className="btn btn-danger"
            style={{ padding: '6px 10px', fontSize: 12 }}
            onClick={() => onDelete?.(pkg)}
          >
            <Icon name="trash" size={13} />
          </button>
        </div>
      ) : null}
    </div>
  );
}
